import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewChild,
} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'nestas-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss']
})
export class NestasSearchbarComponent {
  @Output() search = new EventEmitter<String>();
  @Input() placeholder: string;
  @ViewChild('filterInput') filterInput;

  showClear = false;
  
  constructor(public translate: TranslateService){
  }
}
